import React, { useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { api } from '@/api';
import { useViewerAuth } from '@/contexts/ViewerAuthContext';
import { Loader2 } from 'lucide-react';
import { toast } from 'sonner';

const AuthCallback = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const hasProcessed = useRef(false);
  const { setViewerDirect } = useViewerAuth();

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash;
    const params = new URLSearchParams(hash.replace('#', ''));
    const sessionId = params.get('session_id');

    if (!sessionId) {
      navigate('/signup');
      return;
    }

    const processSession = async () => {
      try {
        const res = await api.viewerGoogleCallback({ session_id: sessionId });
        if (res.data.token) {
          localStorage.setItem('viewer_token', res.data.token);
        }
        // Set viewer in context
        if (setViewerDirect) {
          setViewerDirect(res.data);
        }
        toast.success(`Welcome${res.data.name ? ', ' + res.data.name : ''}!`);
        // If new user, go to preferences
        if (res.data.is_new) {
          navigate('/preferences', { replace: true });
        } else {
          navigate('/live', { replace: true });
        }
      } catch (err) {
        console.error('Google auth callback failed:', err);
        toast.error('Authentication failed. Please try again.');
        navigate('/signup', { replace: true });
      }
    };

    processSession();
  }, [navigate, setViewerDirect]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-950">
      <div className="text-center">
        <Loader2 className="w-8 h-8 animate-spin text-sky-400 mx-auto mb-4" />
        <p className="text-gray-400">Signing you in...</p>
      </div>
    </div>
  );
};

export default AuthCallback;
